import React, { ReactElement } from 'react';
import Link from 'atomic/link/link';

const DigitalServicesActBase: React.FC = (): ReactElement => (
    <div className="digital-service-act">
        <p>
            Średnia miesięczna liczba aktywnych odbiorców usługi opineo.pl której dostawcą jest Ringier Axel Springer
            Polska sp. z o.o. z siedzibą w&nbsp;Warszawie (&quot;RASP&quot;)
        </p>
        <p>
            Zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2022/2065 z dnia 19 października 2022 r.
            w sprawie jednolitego rynku usług cyfrowych oraz zmiany dyrektywy 2000/31/WE (Akt o Usługach Cyfrowych)
            - &quot;DSA&quot;, dostawca usług pośrednich ma obowiązek publikować średnią miesięczną liczbę aktywnych
            odbiorców każdej dostarczanej platformy internetowej. Publikacja ma pomóc organom publicznym zidentyfikować
            bardzo duże platformy internetowe.
        </p>
        <p>
            Średnia miesięczna liczba aktywnych odbiorców usługi opineo.pl, której dostawcą jest RASP, wynosi:
            567&nbsp;179.<br />
            Ostatnia aktualizacja 1.10.2023.
        </p>
        <p>
            Liczba ta została obliczona na podstawie badania Mediapanel, dostarczanego przez Polskie Badania Internetu
            i Gemius, z oszacowaniem liczby aktywnych odbiorców usługi spoza Polski, przygotowanym przez RASP, zgodnie
            z metodyką DSA. Publikacja niniejsza jest realizowana wyłącznie w celu realizacji obowiązku z art.24.2. DSA.
        </p>
        <p>
            Adres do kontaktu: <a href={'mailto:dsa@ringieraxelspringer.pl'}>dsa@ringieraxelspringer.pl</a>
        </p>
        <p>
            <strong>Sprawozdanie przejrzystości zgodne z DSA</strong>
        </p>
        <p>
            Zgodnie z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2022/2065
            z dnia 19 października 2022 r. w sprawie jednolitego rynku usług cyfrowych oraz zmiany
            Dyrektywy 2000/31/WE (akt o usługach cyfrowych), dalej: &bdquo;DSA&rdquo;, oraz Rozporządzeniem
            wykonawczym Komisji (UE) 2024/2835 z dnia 4 listopada 2024 r. ustanawiającym wzory związane
            z wypełnianiem obowiązków sprawozdawczych w zakresie przejrzystości spoczywających
            na dostawcach usług pośrednich i dostawcach platform internetowych na mocy rozporządzenia
            Parlamentu Europejskiego i Rady (UE) 2022/2065,
            dla Serwisu internetowego Opineo (Regulamin:
            {' '}
            <a href={'https://www.opineo.pl/i/dla-uzytkownika/regulamin-dla-uzytkownikow-serwisu'}>
                https://www.opineo.pl/i/dla-uzytkownika/regulamin-dla-uzytkownikow-serwisu
            </a>
            ) stanowiącego platformę internetową, zwanego dalej &bdquo;Usługą&rdquo;
            świadczoną przez Ringier Axel Springer Polska sp. z o.o. z siedzibą w Warszawie, za rok 2025
        </p>
        <p>
            <Link target="_blank" href="https://static.opineo.pl/regulamin/sprawozdanie-transparency-dsa-2025.xlsx">
                Okres sprawozdawczy: 01.01.2025 r. - 31.12.2025 r.
            </Link>
        </p>
        <p>
            <strong>Single Point of Contact</strong>
        </p>
        <p>
            Jeden Punkt Kontaktowy: <a href={'mailto:dsa@ringieraxelspringer.pl'}>SPOC@ringieraxelspringer.pl</a>
            {' '}
            wyznaczony do bezpośredniej komunikacji zgodnie z Aktem o Usługach Cyfrowych dla organów państw
            członkowskich,
            Komisji Europejskiej i Rady Usług Cyfrowych, oraz Użytkowników usług pośrednich. Komunikacja obsługiwana
            w języku polskim lub angielskim.
        </p>
        <p>
            Single Point of Contact: <a href={'mailto:dsa@ringieraxelspringer.pl'}>SPOC@ringieraxelspringer.pl</a>
            {' '}
            designated for direct communication in accordance with the Digital Services Act for Member State
            authorities,
            the European Commission and the Digital Services Board, and also for intermediary services Users.
            Communication
            supported in Polish or English.
        </p>
        <p>
            <strong>Oznaczenie reklam zgodnie z DSA</strong>
        </p>
        <p>
            Reklamy prezentowane na interfejsie platformy internetowej opineo.pl są oznaczone zgodnie
            z Art.26.ust.1 DSA. Użytkownikowi, po naciśnięciu
            symbolu &ldquo;strzałki&rdquo; lub &ldquo;i&rdquo; (informacji)
            w oknie kreacji reklamowej, prezentowane są informacje:

            <ul>
                <li>Kto jest reklamodawcą (w czyim imieniu prezentowana jest reklama)</li>
                <li>Kto zapłacił za reklamę (jeżeli nie jest to reklamodawca)</li>
                <li>Dlaczego widzę tą reklamę (czyli informacja o głównych parametry wykorzystanych do określenia
                    odbiorcy reklamy i sposób zmiany parametrów w stosownych przypadkach np.: profil lub wyrażone
                    zgody na cele marketingowe z linkiem do ustawień/zmiany/wycofania tych zgód)
                </li>
            </ul>
        </p>
    </div>

);

export default DigitalServicesActBase;
